import { CircularProgress } from '@ori-ui/mui';

import { Root } from '../NotifyCumulus/styles';
import { Inner } from './styles';

export const Loading = () => (
  <Root>
    <Inner>
      <CircularProgress size={50} />
    </Inner>
  </Root>
);
